export default {
  routes: [
    {
      path: 'android-autofill',
      name: 'androidAutofillEnabled'
    },
    {
      path: 'macos-credit-card',
      name: 'creditCardAddedMacOS'
    },
    {
      path: 'windows-credit-card',
      name: 'creditCardAddedWindows'
    },
    {
      path: 'ios-safari-extension',
      name: 'iosSafariExtensionAdded'
    },
    {
      path: 'macos-browser-extension',
      name: 'macosBrowserExtensionAdded'
    },
    {
      path: 'import-macos-items',
      name: 'macosImportItems'
    },
    {
      path: 'ios-autofill-enabled',
      name: 'iosAutofillEnabled'
    },
    {
      path: 'new-android-device',
      name: 'newDeviceAddedAndroid'
    },
    {
      path: 'new-ios-device',
      name: 'newDeviceAddediOS'
    },
    {
      path: 'new-macos-device',
      name: 'newDeviceAddedMacOS'
    },
    {
      path: 'new-windows-device',
      name: 'newDeviceAddedWindows'
    },
    {
      path: 'strong-master-password',
      name: 'strongMasterPassword'
    },
    {
      path: 'windows-browser-extension',
      name: 'windowsBrowserExtensionAdded'
    },
    {
      path: 'import-windows-items',
      name: 'windowsImportItems'
    },
    {
      path: 'account-upgrade',
      name: 'accountUpgrade'
    },
    {
      path: 'share-a-bear',
      name: 'shareABear'
    },
    {
      path: 'secure-note-added',
      name: 'secureNoteAdded'
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/mixins/share.js